import { DateValue } from "@internationalized/date";
import { FC } from "react";
import { DropsDatePicker } from "shared/components/Spor";
import { StyleTarget } from "shared/components/StyleTarget";
import { css } from "styled-components";

type MiniDatePickerProps = {
  value: DateValue;
  onChange: (date: DateValue | null) => void;
};

export const MiniDatePicker: FC<MiniDatePickerProps> = ({
  value,
  onChange,
}) => (
  <StyleTarget
    $target="&&&"
    $style={css`
      .spor-field__root > * {
        padding: 0px !important;
      }
      .spor-button {
        outline: none !important;
      }
      .spor-button:hover > * {
        background: ${({ theme }) => theme.colorBackgroundMain} !important;
        outline: 3px solid ${({ theme }) => theme.colorBackgroundMain} !important;
        filter: ${({ theme }) => theme.filterHover};
        border-radius: 6px !important;
      }
      .spor-field__root > * > * > * > * {
        padding-top: 4px !important;
        padding-bottom: 4px !important;
      }
    `}
  >
    <DropsDatePicker
      variant="core"
      value={value}
      onValueChange={onChange}
      withPortal
    />
  </StyleTarget>
);
